export default __webpack_public_path__ + "static/HelveticaNeue-Roman-2b01ff794b4aeafa604e4683f7cf1e08.woff";